import * as yup from "yup";

export const vertexSchema = yup.object({
  x: yup.number().defined(),
  y: yup.number().defined(),
});

export type Vertex = yup.InferType<typeof vertexSchema>;
